import {Component, EventEmitter, Input, OnInit, Output, ViewChild,} from '@angular/core';
import {MatTable, MatTableDataSource} from '@angular/material/table';
import {FormArray, FormBuilder, FormGroup,} from '@angular/forms';
import {MatDialog} from '@angular/material/dialog';
import {isEmpty} from '../../../../../../utils/is-empty';
import {icons} from 'src/app/ui/icons';
import {AddDialogProduitComponent} from '../add-dialog-produit/add-dialog-produit.component';
import {EditDialogProduitComponent} from '../edit-dialog-produit/edit-dialog-produit.component';
import {AppTranslateService} from '../../../../../../modules/services/translate/app-translate.service';
import {ConfirmDialogService} from '../../../../../../modules/services/ui/confirm-dialog.service';

type Column = keyof any;

@Component({
    selector: 'app-produit-table',
    templateUrl: './produit-table.component.html',
    styleUrls: ['./produit-table.component.css'],
})
export class ProduitTableComponent implements OnInit {
    @Input() inputData: any = {};
    errorMsg: string = '';
    @ViewChild(MatTable, {static: true}) table: MatTable<any>;
    @Output() next = new EventEmitter<any>();
    @Output() emitError = new EventEmitter<any>();
    tableForm: FormGroup;
    displayedColumns: Column[] = ['cateId', 'name'];
    dataSource: MatTableDataSource<any> = new MatTableDataSource<any>([]);
    labels: Partial<Record<Column, string>> = {
        cateId: 'Code de la classification des produits',
        name: 'Nom de la classification des produits',
    };
    displayedColumnss: (Column | 'action' | 'N' | 'makeFl')[] = [
        'N',
        ...this.displayedColumns,
        'makeFl',
        'action',
    ];

    icons = icons;

    Ussine: any[] = [];

    constructor(
        private dialog: MatDialog,
        private formBuilder: FormBuilder,
        private appTranslateService: AppTranslateService,
        private confirm: ConfirmDialogService
    ) {
    }

    ngOnInit(): void {
        this.tableForm = this.formBuilder.group({
            listUmRcvSupplierItem: this.formBuilder.array([]),
        });
    }

    add() {
        const dialogRef = this.dialog.open(AddDialogProduitComponent, {
            disableClose: true,
            direction: this.appTranslateService.getDir(),
        });

        dialogRef.afterClosed().subscribe((result) => {
            if (!isEmpty(result)) {
                const isexist = this.dataSource.data.find((x) => {
                    return x.cateId == result.data.cateId;
                });
                if (isexist) {
                    this.confirm.error('produit_exist');
                } else {
                    this.Ussine.push(result.data);
                    this.dataSource.data = this.Ussine;

                    const listUmRcvSupplierItem = this.tableForm.get(
                        'listUmRcvSupplierItem'
                    ) as FormArray;
                    listUmRcvSupplierItem.push(
                        this.formBuilder.group({
                            cateId: [result.data.cateId],
                            makeFl: [result.data.makeFl],
                        })
                    );

                    this.table.renderRows();
                    this._emitError();
                }
            }
        });
    }

    removeCart(index: number, data: any) {
        this.Ussine.splice(index, 1);
        this.dataSource.data = this.Ussine;

        const userCtrl = this.tableForm.get('listUmRcvSupplierItem') as FormArray;

        userCtrl.removeAt(index);
        this._emitError();
    }

    addf() {
        //debugger
        const f = this.tableForm.value;


        if (this.inputData.usine.value.listUmRcvFactory.length > 0) {
            for (const item of f.listUmRcvSupplierItem) {
                if (item.makeFl == 'Y') {
                    this.errorMsg = '';
                    this.tableForm.setErrors(null);
                    this.next.emit(f);


                    return;
                }
            }
            this.errorMsg = 'Il faut au moins un produit avec la mention "Fabricant"';
            this.tableForm.setErrors({'invalid': true});


            return;
        }

        this.errorMsg = '';
        this.tableForm.setErrors(null);
        this.next.emit(f);
    }

    edit(data, index) {

        const dialogRef = this.dialog.open(EditDialogProduitComponent, {
            disableClose: true,
            data: data,
            direction: this.appTranslateService.getDir(),
        });
        dialogRef.afterClosed().subscribe((result) => {

            if (!isEmpty(result)) {
                const isexist = this.dataSource.data.find((x, i) => {
                    return x.cateId == result.data.cateId && i != index;
                });
                if (isexist) {
                    this.confirm.error('produit_exist');
                } else {
                    const t = this.Ussine[index];

                    t.cateId = result.data.cateId;
                    t.makeFl = result.data.makeFl;
                    t.name = result.data.name;

                    this.dataSource.data = this.Ussine;

                    const listUmRcvSupplierItem = this.tableForm.get(
                        'listUmRcvSupplierItem'
                    ) as FormArray;

                    const ta = listUmRcvSupplierItem.at(index);
                    ta.patchValue({
                        cateId: result.data.cateId,
                        makeFl: result.data.makeFl,
                    });
                }

                this.table.renderRows();
                this._emitError();
            }
        });
    }

    _emitError() {
        if (!this.inputData.usine.value.listUmRcvFactory.length) {
            for (const item of this.dataSource.data) {
                if (item.makeFl == 'Y') {
                    this.emitError.emit(true);
                    return;
                }
            }
            this.emitError.emit(false);
            this._setError();
            return;
        }
        this.emitError.emit(false);
        this._setError();
        return;
        // else {
        //     for (const item of this.dataSource.data) {
        //         if (item.makeFl == 'N') {
        //             this.emitError.emit(true);
        //             return;
        //         }
        //     }
        //     this.emitError.emit(false);
        //     return;
        // }
    }

    _setError() {
        // debugger
        const f = this.tableForm.value;

        if (this.inputData.usine.value.listUmRcvFactory.length > 0) {
            for (const item of f.listUmRcvSupplierItem) {
                if (item.makeFl == 'Y') {
                    this.errorMsg = '';
                    this.tableForm.setErrors(null);
                    // this.next.emit(f);
                    return;
                }
            }
            // this.errorMsg = 'Il faut au moins un produit avec la mention "Fabricant"';
            // this.tableForm.setErrors({'invalid': true});
            // return;
        }

        this.errorMsg = '';
        this.tableForm.setErrors(null);
        // this.next.emit(f);
    }

    setProdError(flag) {
        if (!flag) {
            this.errorMsg = '';
            this.tableForm.setErrors(null);
        }
    }
}
